import React from 'react';

/**
 * Generic page skeleton shown while auth / profile resolves.
 * Matches the rough shape of authenticated pages (header + content blocks)
 * so the layout shift feels minimal and there is no blank/spinner flash.
 */
const PageSkeleton: React.FC = () => (
  <div className="min-h-screen bg-dark-950 animate-pulse">
    {/* Nav bar */}
    <div className="h-14 bg-gray-800 border-b border-gray-700" />

    <div className="max-w-6xl mx-auto p-6 space-y-6">
      {/* Page title */}
      <div className="h-7 bg-gray-800 rounded-lg w-48" />

      {/* Card row */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="h-28 bg-gray-800 rounded-xl" />
        <div className="h-28 bg-gray-800 rounded-xl" />
        <div className="h-28 bg-gray-800 rounded-xl" />
      </div>

      {/* Content lines */}
      <div className="space-y-3">
        <div className="h-4 bg-gray-800 rounded w-full" />
        <div className="h-4 bg-gray-800 rounded w-5/6" />
        <div className="h-4 bg-gray-800 rounded w-3/4" />
      </div>

      {/* Second card row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="h-40 bg-gray-800 rounded-xl" />
        <div className="h-40 bg-gray-800 rounded-xl" />
      </div>
    </div>
  </div>
);

export default PageSkeleton;
